import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import moment from "moment";

import DatePicker from "components/atoms/DatePicker/DatePicker";
import TimeInput from "components/atoms/TimeInput/TimeInput";
import Alert from "components/molecules/Alert/Alert";
import PickupDeliveryDate from "pages/shipper/RequestForm/components/Schedule/PickupDeliveryDate";

export default function EditScheduleForm({ countries }: any) {
  const { watch } = useFormContext();
  const [holidays, setHolidays] = useState({});
  const [pickup_date, delivery_date] = [watch("schedule.pickup_date"), watch("schedule.delivery_date")];
  const showError = pickup_date && delivery_date && moment(pickup_date).isSameOrAfter(moment(delivery_date));

  return (
    <>
      <div className="flex-row mt-2">
        <div className="w-192 align-date">
          <label>
            <FormattedMessage id="tracking.components.editScheduleDialog.pickupTime" defaultMessage="Pickup Time" />
          </label>
          <div className="w-192">
            <PickupDeliveryDate
              datePickerProps={{
                name: "schedule.pickup_date",
                required: true,
              }}
              countries={countries}
              holidays={holidays}
              setHolidays={setHolidays}
            />
          </div>
        </div>
        <div className="mt-2 ml-2">
          <label />
          <TimeInput name="schedule.pickup_time" required outputFormat="HH:mm" />
        </div>
      </div>
      <div className="d-flex mt-5">
        <div>
          <label>
            <FormattedMessage
              id="tracking.components.editScheduleDialog.estimatedDeliveryTime"
              defaultMessage="Estimated Delivery Time"
            />
          </label>
          <DatePicker wrapperClassNames="w-192" required name="schedule.delivery_date" />
          {showError && (
            <Alert variant="danger" className="w-192 mt-2">
              <FormattedMessage
                id="quote.provider.schedule.deliveryDateShouldBeGreaterThanPickupDate"
                defaultMessage="Delivery date-time should be greater than pickup date-time (note: timezone is considered as well)"
              />
            </Alert>
          )}
        </div>
        <div className="ml-4 mt-2">
          <label />
          <TimeInput name="schedule.delivery_time" required outputFormat="HH:mm" />
        </div>
      </div>
    </>
  );
}
